export default "__VITE_ASSET__DdOjTQLd__"